export const etnias = [
  // { value: 'afroColombiana', label: 'AfroColombiana' },
  // { value: 'raizal', label: 'Raizal' },
  { value: 'palenqueraNarp', label: 'Comunidades afrocolombianas (NARP)' },
  { value: 'indigena', label: 'Indígenas' },
  { value: 'poblacionGitanaRom', label: 'Población gitana (ROM)' },
  { value: 'No', label: 'No aplica' }
]

export const instituciones = [
  { label: 'Persona Natural', value: 'Persona natural' },
  { label: 'Empresa privada', value: 'Empresa privada' },
  { label: 'Entidad pública', value: 'Entidad pública' },
  { label: 'Fundación', value: 'Fundación' },
  { label: 'Organización', value: 'Organización' },
  { label: 'Organizaciones de acción comunal', value: 'Organizaciones de acción comunal' },
  { label: 'Institución educativa', value: 'Institución educativa' },
  { label: 'Institución de educación superior', value: 'Institución de educación superior' },
  { label: 'Institución de educación técnica', value: 'Institución de educación técnica' },
  { label: 'Institución de educación tecnológica', value: 'Institución de educación tecnológica' },
  { label: 'Prosperidad Social – JEA', value: 'Prosperidad Social – JEA' },
  { label: 'Otra', value: 'Otra' }
]

export const tiposDocumento = [
  { label: 'Cédula de ciudadanía', value: 'CC' },
  { label: 'Tarjeta de identidad', value: 'TI' },
  { label: 'Número único de identificación (NUIP)', value: 'NUIP' },
  { label: 'Registro civil', value: 'RC' },
  { label: 'Cédula de extranjería', value: 'CE' }
]

export const generos = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Femenino' }
]

export const tiposSolicitudes = [
  { label: 'Petición', value: 'peticion' },
  { label: 'Soporte a la inscripción', value: 'soporte_inscripcion' },
  { label: 'Soporte del curso', value: 'soporte_curso' },
  { label: 'Soporte en el uso del sistema', value: 'soporte_sistema' },
  { label: 'Problemas con la clave', value: 'problemas_clave' },
  { label: 'Queja', value: 'queja' }
]
